import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HeatmapSite, HeatmapAggregatesResponse, HeatmapStatistics } from '../../../services/heatmap.service';

interface HeatmapState {
    sites: HeatmapSite[];
    sitesLoading: boolean;
    totalSites: number;

    statistics: HeatmapStatistics | null;
    statisticsLoading: boolean;

    aggregates: HeatmapAggregatesResponse | null;
    aggregatesLoading: boolean;
}

const initialState: HeatmapState = {
    sites: [],
    sitesLoading: false,
    totalSites: 0,

    statistics: null,
    statisticsLoading: false,

    aggregates: null,
    aggregatesLoading: false,
};

const heatmapSlice = createSlice({
    name: 'heatmap',
    initialState,
    reducers: {
        setSites: (state, action: PayloadAction<HeatmapSite[]>) => { state.sites = action.payload; },
        setSitesLoading: (state, action: PayloadAction<boolean>) => { state.sitesLoading = action.payload; },
        setTotalSites: (state, action: PayloadAction<number>) => { state.totalSites = action.payload; },

        setStatistics: (state, action: PayloadAction<HeatmapStatistics | null>) => { state.statistics = action.payload; },
        setStatisticsLoading: (state, action: PayloadAction<boolean>) => { state.statisticsLoading = action.payload; },

        setAggregates: (state, action: PayloadAction<HeatmapAggregatesResponse | null>) => { state.aggregates = action.payload; },
        setAggregatesLoading: (state, action: PayloadAction<boolean>) => { state.aggregatesLoading = action.payload; },

        resetHeatmapState: () => initialState,
    },
});

export const {
    setSites,
    setSitesLoading,
    setTotalSites,
    setStatistics,
    setStatisticsLoading,
    setAggregates,
    setAggregatesLoading,
    resetHeatmapState,
} = heatmapSlice.actions;

export default heatmapSlice.reducer;
